import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Thu Aug 09 2018
 * @author VBr, LZe
 */
import * as React from 'react';
import Input from '../../../../inputs/Input';
import FormGroup from '../../../../forms/FormGroup/FormGroup';
import Label from '../../../../typography/Label';
import FilterWrapper from './FilterWrapper';
import Filter from './Filter';
/**
 * Filter selecting number interval
 */

var RangeFilter =
/*#__PURE__*/
function (_Filter) {
  _inherits(RangeFilter, _Filter);

  function RangeFilter() {
    var _this;

    _classCallCheck(this, RangeFilter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RangeFilter).apply(this, arguments));
    _this.state = {
      from: '',
      to: ''
    };
    /**
     * Sets input values
     * @param event Input's event object
     * @param results Validation results
     */

    _this.onChange = function (event) {
      if (_this.state[event.target.name] !== event.target.value) {
        if (event.target.name === 'from') {
          _this.setState({
            from: event.target.value
          }, _this.props.filterChangedCallback);
        }

        if (event.target.name === 'to') {
          _this.setState({
            to: event.target.value
          }, _this.props.filterChangedCallback);
        }
      }
    };
    /**
     * Resets input values and clears filter
     */


    _this.onClear = function () {
      _this.setState({
        from: '',
        to: ''
      }, _this.closePopup);
    };

    return _this;
  }
  /**
   * This function determines wheter column's filter is active
   */


  _createClass(RangeFilter, [{
    key: "isFilterActive",
    value: function isFilterActive() {
      return this.state.from !== null && this.state.from !== undefined && this.state.from !== '' || this.state.to !== null && this.state.to !== undefined && this.state.to !== '';
    }
    /**
     * This function determines wheter each node passes the filter
     * In case of tree view this applies only from the lowest level
     * If there's a children matching filter, parent gets displayed even if it doesn't pass itself
     */

  }, {
    key: "doesFilterPass",
    value: function doesFilterPass(params) {
      return (!this.state.from || Number(this.props.valueGetter(params.node)) >= Number(this.state.from)) && (!this.state.to || Number(this.props.valueGetter(params.node)) <= Number(this.state.to));
    }
    /**
     * This function is for getColumnState() output and similar
     */

  }, {
    key: "getModel",
    value: function getModel() {
      return {
        from: this.state.from,
        to: this.state.to
      };
    }
    /**
     * This function set filter state from setColumnState() input and similar
     * @param model data input
     */

  }, {
    key: "setModel",
    value: function setModel(model) {
      this.setState({
        from: model ? model.from : '',
        to: model ? model.to : ''
      }, this.props.filterChangedCallback);
    }
    /**
     * Updates filter if value in floating filter changes
     * @param model object with filter state
     */

  }, {
    key: "onFloatingFilterChanged",
    value: function onFloatingFilterChanged(model) {
      if (!model) {
        this.setState({
          from: '',
          to: ''
        }, this.props.filterChangedCallback);
      } else {
        this.setState({
          from: model.from,
          to: model.to
        }, this.props.filterChangedCallback);
      }
    }
    /**
     * Renders filter component
     */

  }, {
    key: "render",
    value: function render() {
      return React.createElement(FilterWrapper, {
        onApply: this.onApply,
        onClear: this.onClear
      }, React.createElement(FormGroup, {
        noLabel: false
      }, React.createElement(Label, null, "From:"), React.createElement(Input, {
        type: "number",
        tiny: true,
        name: "from",
        value: this.state.from,
        onChange: this.onChange
      })), React.createElement(FormGroup, {
        noLabel: false
      }, React.createElement(Label, null, "To:"), React.createElement(Input, {
        type: "number",
        tiny: true,
        name: "to",
        value: this.state.to,
        onChange: this.onChange
      })));
    }
  }]);

  return RangeFilter;
}(Filter);

export { RangeFilter as default };